import { formatDate } from '@angular/common';
import { Component, Inject, LOCALE_ID, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { debounceTime } from 'rxjs/operators';
import { ClaveService } from 'src/app/_services/clave.service';
import { CsvgenerateService } from 'src/app/_services/csvgenerate/csvgenerate.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { ServicioGeneral } from 'src/app/_services/servicio-general.service';
import { SolicituCustomService } from 'src/app/_services/solicitud-custom.service';
import { TokenStorageService } from 'src/app/_services/token-storage.service';
import { BoardAdminComponent } from 'src/app/board-admin/board-admin.component';
import { EstadoTramiteReturn, TramiteEmvs } from '../listado-tramites-emvs/tramite-emvs';


export type NotificacionDTO = {
  "Concepto remesa": string,
  "Procedimiento nombre": string,
  "NIF": string,
  "Leido": boolean,
  "Fecha creación": Date
  "Email titular": string,
  "Estado": string,
  "Tipo envio": string
};
@Component({
  selector: 'app-listado-notificaciones-emvs',
  templateUrl: './listado-notificaciones-emvs.component.html',
  styleUrls: [
    '../listado-tramites-emvs/listado-tramites-emvs.component.scss',
    './listado-notificaciones-emvs.component.scss',
  ],
})
export class ListadoNotificacionesEmvsComponent {


  private readonly columnasBase = [
    "Concepto remesa",
    "Procedimiento nombre",
    "Fecha creación",
    "NIF",
    "Leido",
    "Email titular",
    "Tipo envio",
    "Estado",
  ];
  displayedColumns: string[] = [...this.columnasBase];
  private readonly colKeys: Record<string, string> = {
    'Concepto remesa': 'NOTIFICACIONES.COL.CONCEPTO',
    'Procedimiento nombre': 'NOTIFICACIONES.COL.PROC',
    'Fecha creación': 'NOTIFICACIONES.COL.FECHA',
    'NIF': 'NOTIFICACIONES.COL.NIF',
    'Leido': 'NOTIFICACIONES.COL.LEIDO',
    'Email titular': 'NOTIFICACIONES.COL.EMAIL',
    'Tipo envio': 'NOTIFICACIONES.COL.TIPO',
    'Estado': 'NOTIFICACIONES.COL.ESTADO',
  };
  dataSource = new MatTableDataSource<NotificacionDTO>();

  get totalNotificaciones(): number { return this.dataSource?.data?.length || 0; }
  get notificacionesMostradas(): number { return this.dataSource?.filteredData?.length ?? this.totalNotificaciones; }

  request: TramiteEmvs[];
  requestCsv: any[];

  user = this.tokenStorageService.getUser()
  userId = this.user["id"]
  isAdmin: boolean = Math.max(...this.user["rol"]) > 1;
  idCurrentPdf: number = 0;
  notificacionesDto: NotificacionDTO[] = [];
  cargaTotal: boolean = false;
  display: string = 'none';
  diasCaducidad: string = localStorage.getItem('tramiteMaxDays');
  estadoTramiteReturn = EstadoTramiteReturn;
  deleteCurrenTramite: TramiteEmvs = {
    id: -1
  }
  selectedTramite: any;
  selectedOpcion: String = 'Firmar con Autofirma';
  displayFirma: string = 'none';
  filteredValues: any =
    {
      DNI: '',
      Nombre: '',
      FechaDesde: '',
      FechaHasta: '',
      Estado: '',
      PasoTramite: ''
    };
  filtroDNI = new FormControl();
  filtroNombre = new FormControl();
  filtroFecha = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  })
  filtroTipoEnvio = new FormControl('');
  filtroPaso = new FormControl('');
  filtroCargaTotal = new FormControl(false);
  cargandoTramites: boolean = false;
  filtersOpen: boolean = false;

  get activeFilterCount(): number {
    let count = 0;
    if (this.filteredValues['DNI']) count++;
    if (this.filteredValues['Nombre']) count++;
    if (this.filteredValues['FechaDesde']) count++;
    if (this.filteredValues['TipoEnvio']) count++;
    if (this.filtroCargaTotal.value) count++;
    return count;
  }
  tabTraduccion = {
    "personales-tab": "Datos solicitante",
    "representacionReducida-tab": "Datos representante",
    "instancia-tab": "Expone/Solicita",
    "politicas-tab": "Política de privacidad",
    "representacion-tab": "Datos representante",
    "circunstancias-tab": "Circunstancias económicas",
    "unidad-tab": "Datos unidad familiar",
    "distritos-tab": "Distritos municipales",
    "vulnerabilidad-tab": "Situación vulnerabilidad",
    "autorizacion-tab": "Autorización de consulta",
    "ficheros-tab": "Carga de ficheros",
    "puestos-tab": "Puestos solicitados"
  };
  tabTraduccionB = {
    "Datos solicitante": "personales-tab",
    "Datos representante": "representacion",
    "Expone/Solicita": "instancia-tab",
    "Política de privacidad": "politicas-tab",
    "Circunstancias económicas": "circunstancias-tab",
    "Datos unidad familiar": "unidad-tab",
    "Distritos municipales": "distritos-tab",
    "Situación vulnerabilidad": "vulnerabilidad-tab",
    "Autorización de consulta": "autorizacion-tab",
    "Carga de ficheros": "ficheros-tab",
    "Puestos solicitados": "puestos-tab"
  };
  listadoTipoEnvio: any = [];
  listadoPasos: any = [{ label: '' }];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  mensajeSpinner: string;
  constructor(
    private tokenStorageService: TokenStorageService,
    private _csvgenerate: CsvgenerateService,
    private _notificationSvc: NotificationService,
    private paginatorIntl: MatPaginatorIntl,
    private _boardAdmin: BoardAdminComponent,
    private _router: Router,
    private _servicioGeneral: ServicioGeneral,
    private _claveService: ClaveService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private _solicituCustomService: SolicituCustomService,
    public translate: TranslateService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.traduccionPaginator();
  }

  ngOnInit(): void {
    this.listTipoEnvio();
    this.cargarNotificaciones();
    this.cargaTotal = false;
    this.filtroDNI.valueChanges.pipe(debounceTime(400)).subscribe((valorFiltroDNI) => {
      this.filteredValues['DNI'] = valorFiltroDNI;
      this.cargarNotificaciones();
    });

    this.filtroTipoEnvio.valueChanges.subscribe((valorFiltroTipoEnvio) => {
      this.filteredValues['TipoEnvio'] = valorFiltroTipoEnvio;
      this.cargarNotificaciones();
    });

    this.filtroNombre.valueChanges.pipe(debounceTime(400)).subscribe((valorFiltroNombre) => {
      this.filteredValues['Nombre'] = valorFiltroNombre;
      this.cargarNotificaciones();
    });
    this.filtroFecha.controls['start'].valueChanges.pipe(debounceTime(400)).subscribe((valorFiltroFechaDesde) => {
      this.filteredValues['FechaDesde'] = valorFiltroFechaDesde;
      this.cargarNotificaciones();
    });
    this.filtroFecha.controls['end'].valueChanges.pipe(debounceTime(400)).subscribe((valorFiltroFechaHasta) => {
      this.filteredValues['FechaHasta'] = valorFiltroFechaHasta;
      this.cargarNotificaciones();
    });

    this.filtroCargaTotal.valueChanges.subscribe((valorFiltroPaso) => {
      this.cargaTotal = valorFiltroPaso;
      this.cargarNotificaciones();
    });


  }
  listTipoEnvio() {

    this.notificacionesDto = [];
    this._servicioGeneral.getListTipoTramite().subscribe({
      next: (data) => {
        this.listadoTipoEnvio = data;
        console.log(data)
      }, error(err) {

      },

    });


  }

  cargarNotificaciones() {
    this.notificacionesDto = [];
    this.cargandoTramites = true;
    this.mostrarSpinnerMsg(this.translate.instant('COMMON.LOADING'));
    this._servicioGeneral.getNotificacionesPage(
      this.cargaTotal,
      this.filteredValues['FechaDesde'],
      this.filteredValues['FechaHasta'],
      this.filteredValues['DNI'],
      this.filteredValues['Nombre'],
      this.filteredValues['TipoEnvio'],

    ).subscribe({
      next: (data) => {
        this.request = data;
        console.log("data");
        console.log(data);
        data
          .forEach(notificacion => {
            const dateObj = new Date(
              notificacion.fechaCreacion[0],
              (notificacion.fechaCreacion[1] ?? 1) - 1,
              notificacion.fechaCreacion[2],
              notificacion.fechaCreacion[3],
              notificacion.fechaCreacion[4],
            );
            var notificacionDto: NotificacionDTO = {
              "Concepto remesa": notificacion.remesa.concepto,
              "Procedimiento nombre": notificacion.remesa.procedimiento_id?.nombre,
              "Fecha creación": dateObj,
              "NIF": notificacion.nifTitular,
              "Leido": notificacion.leido,
              "Email titular": notificacion.emailTitular,
              "Estado": this.resolveEstadoCodigo(notificacion),
              "Tipo envio": notificacion.remesa.tipoEnvio.nombre,
            };
            this.notificacionesDto.push(notificacionDto);

          });
        console.log(this.notificacionesDto)
        this.dataSource = new MatTableDataSource(this.notificacionesDto);
        this.dataSource.filterPredicate = this.customFilterPredicate();
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sortingDataAccessor =
          (data: object, sortHeaderId: string): string | number => {
            const propPath = sortHeaderId.split('.');
            const value: any = propPath
              .reduce((curObj, property) => curObj[property], data);
            return !isNaN(value) ? Number(value) : value;
          };
        this.cargandoTramites = false;

        this.ocultarSpinner();


      },
      error: (err) => {
        console.log(err);
        this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('NOTIFICACIONES.MSG.LOAD_FAIL'), 3000);
        this.cargandoTramites = false;
        this.ocultarSpinner();
      },
    })

  }


  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
    this.filteredValues['FechaDesde'] = dateRangeStart?.value;
    this.filteredValues['FechaHasta'] = dateRangeEnd?.value;
    this.dataSource.filter = JSON.stringify(this.filteredValues);
  }
  customFilterPredicate() {
    return function (data: NotificacionDTO, filter: string): boolean {
      let searchString = JSON.parse(filter);
      var enRango = true;
      if (searchString.FechaDesde) {
        let compareDate = new Date(data['Fecha']);
        compareDate.setHours(0, 0, 0, 0);
        let startDate = new Date(searchString.FechaDesde);
        startDate.setHours(0, 0, 0, 0);
        if (compareDate.getTime() >= startDate.getTime()) {
          enRango = true;
        }
        else {
          enRango = false;
        }
      }
      if (searchString.FechaHasta && enRango) {
        let compareDate = new Date(data['Fecha']);
        compareDate.setHours(0, 0, 0, 0);
        let endDate = new Date(searchString.FechaHasta);
        endDate.setHours(23, 59, 59, 0);
        if (compareDate.getTime() <= endDate.getTime()) {
          enRango = true;
        }
        else {
          enRango = false;
        }
      }
      return enRango
        && (!searchString.DNI || data['DNI']?.toString().toLowerCase().trim().indexOf(searchString.DNI?.toLowerCase().trim()) !== -1)
        && (!searchString.Nombre || data['Nombre del trámite']?.toString().toLowerCase().trim().toLowerCase().indexOf(searchString.Nombre?.toLowerCase().trim()) !== -1)
        && (!searchString.Estado || data['Estado']?.toString().toLowerCase().trim().toLowerCase().indexOf(searchString.Estado?.toLowerCase().trim()) !== -1)
        && (!searchString.PasoTramite || (data['Último paso trámite'] && data['Último paso trámite']?.toString().toLowerCase().trim().indexOf(searchString.PasoTramite?.toLowerCase().trim()) !== -1))
        ;
    }
  }

  formatoFecha(date) {
    if (date) {
      let month = (date[1] < 10) ? '0' + date[1] : date[1];
      let day = (date[2] < 10) ? '0' + date[2] : date[2];
      let year = date[0];
      let hour = (date[3] < 10) ? '0' + date[3] : date[3];
      let min = (date[4] < 10) ? '0' + date[4] : date[4];
      let seg = (date[5]) ? ((date[5] < 10) ? '0' + date[5] : date[5]) : '00';
      return [year, month, day].join('-').concat('T' + [hour, min, seg].join(':') + '.000Z');
    }
    return ''
  }

  formatDate(date: Date) {
    return formatDate(date, 'dd-MM-yyyy HH:mm', this.locale, 'GMT');
  }
  formatDateWithoutHour(date: Date) {
    return formatDate(date, 'dd-MM-yyyy', this.locale, 'GMT');
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }




  private traduccionPaginator(): void {
    this.paginatorIntl.itemsPerPageLabel = "Registros por página";
    this.paginatorIntl.firstPageLabel = '';
    this.paginatorIntl.previousPageLabel = '';
    this.paginatorIntl.nextPageLabel = '';
    this.paginatorIntl.lastPageLabel = '';
    this.paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 de ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} de ${length}`;
    };
  }






  public valuesEnum(object): boolean {
    return Object.values(this.estadoTramiteReturn).includes(object)
  }

  signTramite(tramite: any) {
    this.displayFirma = 'block';
    this.selectedTramite = tramite;
  }


  limpiarParametros() {
    this._router.navigate([], {
      queryParams: {
        'rId': null,
        'a': null,
        't': null,
      },
      queryParamsHandling: 'merge'
    });
  }
  cargarMas() {
    const newSize = this.paginator.pageSize + 10;
    this.paginator.pageSize = newSize;
    this.dataSource.paginator = this.paginator;
  }

  clearFilters() {
    this.filtroDNI.setValue('');
    this.filtroNombre.setValue('');
    this.filtroFecha.reset();
    this.filtroTipoEnvio.setValue('');
    this.filtroCargaTotal.setValue(false);
  }

  mostrarSpinnerMsg(mensaje: string) {
    this.mensajeSpinner = mensaje;
    this.spinner.show('litado_notificaciones_spinner');
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide('litado_notificaciones_spinner');
    }, 60000);
  }
  ocultarSpinner() {
    this.spinner.hide('litado_notificaciones_spinner');
  }
  exportarCsv() {
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this._csvgenerate.generateCsvNotificaciones(this.request, this.filteredValues);
      this.ocultarSpinner();
    }, 100);
  }

  colLabel(column: string): string {
    const key = this.colKeys[column];
    return key ? this.translate.instant(key) : column;
  }

  resolveEstadoCodigo(notificacion: any): string {
    const raw = (notificacion?.estado ?? '').toString().trim();
    const tipo = notificacion?.remesa?.tipoEnvio?.nombre;
    if (tipo === 'Comunicación') {
      return raw ? 'ENVIADO' : 'PENDIENTE';
    }
    return raw || 'PENDIENTE';
  }

  estadoLabel(estado: string): string {
    switch ((estado || '').trim()) {
      case 'ENVIADO':
        return this.translate.instant('NOTIFICACIONES.ESTADO.ENVIADO');
      case 'ACEPTADA':
        return this.translate.instant('REMESAS.ESTADO_ENVIO.ACEPTADA');
      case 'RECHAZADA':
        return this.translate.instant('REMESAS.ESTADO_ENVIO.RECHAZADA');
      case 'RECHAZADA AUTOMATICAMENTE':
        return this.translate.instant('REMESAS.ESTADO_ENVIO.RECHAZADA_AUTO');
      case 'PENDIENTE DE ENVIO':
        return this.translate.instant('REMESAS.ESTADO_ENVIO.PENDIENTE_ENVIO');
      case 'PENDIENTE':
        return this.translate.instant('REMESAS.ESTADO_ENVIO.PENDIENTE');
      default:
        return estado || this.translate.instant('REMESAS.ESTADO_ENVIO.PENDIENTE');
    }
  }

  estadoPillClass(estado: string): string {
    switch ((estado || '').trim()) {
      case 'ENVIADO':
      case 'ACEPTADA':
        return 'estado-pill--enviado';
      case 'RECHAZADA':
      case 'RECHAZADA AUTOMATICAMENTE':
        return 'estado-pill--rechazada';
      case 'PENDIENTE DE ENVIO':
        return 'estado-pill--pendiente-envio';
      case 'PENDIENTE':
      default:
        return 'estado-pill--pendiente';
    }
  }
}